import type Map from './index.vue'

export type MapInstance = InstanceType<typeof Map>

/**
 * 显示图层枚举
 */
export enum ShowLayerType {
  SHOWGLOBALEMISSIONCONTROLAREA = 'showGlobalEmissionControlArea',
  SHOWBASELINEOFCHINATERRITORIALSEA = 'showBaselineOfChinaTerritorialSea',
  SHOWSTRAITSOFGLOBALIMPORTANCE = 'showStraitsOfGlobalImportance',
  SHOWGLOBALMARINEAREA = 'showGlobalMarineArea',
  SHOWGLOBALTIMEZONE = 'showGlobalTimeZone',
  SHOWWARPANDLATITUDEGRID = 'showWarpAndLatitudeGrid',
  SHOWSEAAREAFORECAST = 'showSeaAreaForecast',
  SHOWTYPHOON = 'showTyphoon',
  SHOWSEABREEZE = 'showSeaBreeze',
  SHOWTIDE = 'showTide',
  SHOWSEAROUTE = 'showSeaRoute',
  SHOWFISHERYMANAGER = 'showFisheryManager',
  SHOWEARTHQUAKEAREASYMBOL = 'showEarthQuakeAreaSymbol',
  SHOWPIRATESSYMBOL = 'showPiratesSymbol',
  SHOWCOLLISIONRISKSYMBOL = 'showCollisionRiskSymbol',
  SHOWOBSTACLEAREASYMBOL = 'showObstacleareaSymbol',
  SHOWAISMANAGER = 'showAisManager',
  SHOWPORT = 'showPort',
  SHOWFINSHAREASYMBOL = 'showFinshAreaSymbol',
  SHOWWIND = 'showWind',
  SHOWHL = 'showHL',
  SHOWHAILANG = 'showHaiLang',
  SHOWWATERTEMPERATURE = 'showWaterTemperature',
  SHOWICECONDITION = 'showIceCondition',
  SHOWSEAICE = 'showSeaIce',
  SHOWSEABREEZELAYER = 'showSeaBreezeLayer',
  SHOWSEABREEZEARROW = 'showSeaBreezeArrow',
  SHOWRAINFALL = 'showRainfall',
  SHOWATMOSPHERICPRESSURE = 'showAtmosphericPressure',
  SHOWVISIBILITY = 'showVisibility',
  SHOWAIRTEMPERATURE = 'showAirTemperature',
  SHOWSEAWAVE = 'showSeaWave',
  SHOWWAVEARROW = 'showWaveArrow',
  SHOWYANGLIU = 'showYangliu',
  SHOWSHIPACCIDENT = 'showShipAccidentSymbol',
  SHOWTERMINATOR = 'showTerminatorSymbol',
  SHOWGLOBALEEZAREA = 'showGlobalEEZArea',
}

export const weatherList = [
  {
    seaarea: '巴士海峡',
    publishtime: '2024年06月24日08时',
    centerlatitude: '19.77',
    centerlongititude: '121.17',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '北部湾',
    publishtime: '2024年06月24日08时',
    centerlatitude: '19.08',
    centerlongititude: '107.28',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '渤海',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.65',
    centerlongititude: '119.51',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '20',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '20',
      },
    ],
  },
  {
    seaarea: '渤海海峡',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.2',
    centerlongititude: '121.2',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '20',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '东南风',
        windpower: '2-3',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
    ],
  },
  {
    seaarea: '东海北部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '30.96',
    centerlongititude: '127.23',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '小雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '10',
      },
      {
        forecastaging: '36-48',
        meteorological: '大雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '6',
      },
      {
        forecastaging: '48-60',
        meteorological: '小雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '10',
      },
      {
        forecastaging: '60-72',
        meteorological: '暴雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: '1.5',
        visibility: '3',
      },
    ],
  },
  {
    seaarea: '东海南部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '26.27',
    centerlongititude: '122.67',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '小雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '10',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '小雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '10',
      },
    ],
  },
  {
    seaarea: '黄海北部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.35',
    centerlongititude: '123.3',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西北风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '20',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西北风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '20',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '20',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '2-3',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '20',
      },
    ],
  },
  {
    seaarea: '黄海南部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '33.3',
    centerlongititude: '123.3',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '东北风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '小雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '10',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '暴雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '3',
      },
    ],
  },
  {
    seaarea: '黄海中部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '35.3',
    centerlongititude: '122.45',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '西北风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '西北风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '20',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '2-3',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '2-3',
        waveheight: '0.5',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东北风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '南海东北部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '20.38',
    centerlongititude: '116.82',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '南海东南部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '8',
    centerlongititude: '114.22',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '南海西北部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '20.1',
    centerlongititude: '111.77',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '南海西南部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '13.05',
    centerlongititude: '110.94',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '南海中东部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '15.9',
    centerlongititude: '118.13',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '南海中西部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '16.7',
    centerlongititude: '109.43',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '琼州海峡',
    publishtime: '2024年06月24日08时',
    centerlatitude: '20.2',
    centerlongititude: '110.2',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '8',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '小雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '10',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '0.5',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '台湾海峡',
    publishtime: '2024年06月24日08时',
    centerlatitude: '24.23',
    centerlongititude: '119.7',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '1.5',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '台湾以东洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '23.25',
    centerlongititude: '121.86',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '安达曼海',
    publishtime: '2024年06月24日08时',
    centerlatitude: '11.91',
    centerlongititude: '96',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '大雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '6',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '大雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '6',
      },
      {
        forecastaging: '36-48',
        meteorological: '大雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '6',
      },
      {
        forecastaging: '48-60',
        meteorological: '大雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '6',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '北马里亚纳群岛以西洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '18',
    centerlongititude: '135',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '朝鲜海峡',
    publishtime: '2024年06月24日08时',
    centerlatitude: '34.51',
    centerlongititude: '129.29',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '小雨',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '10',
      },
      {
        forecastaging: '60-72',
        meteorological: '大雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '6',
      },
    ],
  },
  {
    seaarea: '菲律宾东北洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '17.25',
    centerlongititude: '127.09',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '菲律宾东南洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '10',
    centerlongititude: '130',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '关岛以西洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '10',
    centerlongititude: '135',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '大雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '6',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '琉球群岛以东洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '27',
    centerlongititude: '130.3',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '2.0',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '马六甲海峡',
    publishtime: '2024年06月24日08时',
    centerlatitude: '3.69',
    centerlongititude: '100.13',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '日本海东北部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '42.05',
    centerlongititude: '136.34',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '东北风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '西风',
        windpower: '5-6',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '西风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '20',
      },
    ],
  },
  {
    seaarea: '日本海西南部',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.7',
    centerlongititude: '133.35',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '小雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '西风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '日本以南洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '32',
    centerlongititude: '137.29',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '6-7',
        waveheight: '3.0',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '6-7',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '6-7',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '西风',
        windpower: '5-6',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '西风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '苏门答腊以南洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '-4.17',
    centerlongititude: '97.98',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: '3.0',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '3.0',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '3.0',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '3.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '3.0',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '泰国湾',
    publishtime: '2024年06月24日08时',
    centerlatitude: '9.97',
    centerlongititude: '101.8',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '小笠原群岛以西洋面',
    publishtime: '2024年06月24日08时',
    centerlatitude: '27',
    centerlongititude: '135',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.0',
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '新加坡以东海域',
    publishtime: '2024年06月24日08时',
    centerlatitude: '3.38',
    centerlongititude: '106.59',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '15',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '2-3',
        waveheight: '0.5',
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '印度尼西亚东北海域',
    publishtime: '2024年06月24日08时',
    centerlatitude: '3',
    centerlongititude: '135',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '2-3',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '2-3',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: '1.5',
        visibility: '8',
      },
    ],
  },
  {
    seaarea: '印度尼西亚东南海域',
    publishtime: '2024年06月24日08时',
    centerlatitude: '-3.93',
    centerlongititude: '126.36',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '越南以南海域',
    publishtime: '2024年06月24日08时',
    centerlatitude: '8.39',
    centerlongititude: '107.05',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: '1.0',
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: '0.5',
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '爪哇岛以北海域',
    publishtime: '2024年06月24日08时',
    centerlatitude: '-4.55',
    centerlongititude: '111.62',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '1.0',
        visibility: '15',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '1.5',
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '爪哇岛以南海域',
    publishtime: '2024年06月24日08时',
    centerlatitude: '-9.21',
    centerlongititude: '117.95',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '3.0',
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: '3.0',
        visibility: '15',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: '2.5',
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '北部湾东北部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '20.818',
    centerlongititude: '109.472',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '17',
      },
      {
        forecastaging: '12-24',
        meteorological: '大雨',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '17',
      },
      {
        forecastaging: '36-48',
        meteorological: '大雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
    ],
  },
  {
    seaarea: '北部湾西北部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '21.45',
    centerlongititude: '108.7',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '大雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '12-24',
        meteorological: '大雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '24-36',
        meteorological: '大雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '36-48',
        meteorological: '大雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '5',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '5',
      },
    ],
  },
  {
    seaarea: '渤海北部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '40.47',
    centerlongititude: '121.1',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '东北东',
        windpower: '3-4',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '15',
      },
    ],
  },
  {
    seaarea: '渤海海峡中南部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.1',
    centerlongititude: '120.85',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西北风',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
    ],
  },
  {
    seaarea: '渤海南部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38',
    centerlongititude: '119.633',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '北北东',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '西北风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '多云',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '渤海湾',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.906',
    centerlongititude: '118.949',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '沧州沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.516',
    centerlongititude: '118.183',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
    ],
  },
  {
    seaarea: '川山群岛沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '21.532',
    centerlongititude: '112.475',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '6-7',
        waveheight: null,
        visibility: '17',
      },
      {
        forecastaging: '12-24',
        meteorological: '大雨',
        winddirection: '南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '8',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '5-6',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '36-48',
        meteorological: '大雨',
        winddirection: '南南东',
        windpower: '5-6',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '17',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '福建北部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '26.7',
    centerlongititude: '121.08',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '南南西',
        windpower: '5-6',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '南南西',
        windpower: '3-4',
        waveheight: null,
        visibility: '21',
      },
    ],
  },
  {
    seaarea: '福建南部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '24.22',
    centerlongititude: '118.56',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '48-60',
        meteorological: '小雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '18',
      },
    ],
  },
  {
    seaarea: '福建中部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '25.43',
    centerlongititude: '120',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '12-24',
        meteorological: '阴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '24-36',
        meteorological: '阴',
        winddirection: '南南西',
        windpower: '3-4',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '17',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '西南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '21',
      },
    ],
  },
  {
    seaarea: '海南东部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '19.26',
    centerlongititude: '111.11',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '12-24',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '36-48',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '48-60',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
    ],
  },
  {
    seaarea: '海南南部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '17.9',
    centerlongititude: '109.45',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '12-24',
        meteorological: '雷阵雨',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: null,
        visibility: '7',
      },
      {
        forecastaging: '24-36',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '48-60',
        meteorological: '雷阵雨',
        winddirection: '东南东',
        windpower: '5-6',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
    ],
  },
  {
    seaarea: '海南西部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '19.474',
    centerlongititude: '108.292',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '雷阵雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '12-24',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '6',
      },
      {
        forecastaging: '24-36',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '36-48',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '48-60',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
    ],
  },
  {
    seaarea: '连云港沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '34.76',
    centerlongititude: '120.56',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '东北风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '48-60',
        meteorological: '阵雨',
        winddirection: '东风',
        windpower: '6-7',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '东北东',
        windpower: '6-7',
        waveheight: null,
        visibility: '9',
      },
    ],
  },
  {
    seaarea: '辽东半岛东部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '39.26',
    centerlongititude: '123.22',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '3-4',
        waveheight: null,
        visibility: '16',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西北风',
        windpower: '3-4',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '东南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '14',
      },
    ],
  },
  {
    seaarea: '辽东半岛南部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.728',
    centerlongititude: '121.827',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '3-4',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '3-4',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '14',
      },
    ],
  },
  {
    seaarea: '辽东半岛西部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '39.36',
    centerlongititude: '120.82',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '北风',
        windpower: '3-4',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '3-4',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '3-4',
        waveheight: null,
        visibility: '13',
      },
    ],
  },
  {
    seaarea: '南通沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '32.32',
    centerlongititude: '122.25',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阵雨',
        winddirection: '北风',
        windpower: '5-6',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '24-36',
        meteorological: '阵雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '36-48',
        meteorological: '大雨',
        winddirection: '东风',
        windpower: '7-8',
        waveheight: null,
        visibility: '7',
      },
      {
        forecastaging: '48-60',
        meteorological: '大雨',
        winddirection: '东南风',
        windpower: '7-8',
        waveheight: null,
        visibility: '7',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '西南风',
        windpower: '7-8',
        waveheight: null,
        visibility: '9',
      },
    ],
  },
  {
    seaarea: '秦皇岛沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '39.684',
    centerlongititude: '119.721',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '西南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '3-4',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
    ],
  },
  {
    seaarea: '琼州海峡',
    publishtime: '2024年06月24日08时',
    centerlatitude: '20.2',
    centerlongititude: '110.2',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '7',
      },
      {
        forecastaging: '12-24',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '21',
      },
      {
        forecastaging: '24-36',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '48-60',
        meteorological: '雷阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
    ],
  },
  {
    seaarea: '山东半岛北部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '38.022',
    centerlongititude: '122.2',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '北北西',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '晴',
        winddirection: '东风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '1',
      },
    ],
  },
  {
    seaarea: '山东半岛东部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '37.22',
    centerlongititude: '123.01',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '北北西',
        windpower: '4-5',
        waveheight: null,
        visibility: '13',
      },
      {
        forecastaging: '12-24',
        meteorological: '晴',
        winddirection: '西北西',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '24-36',
        meteorological: '小雨',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '36-48',
        meteorological: '晴',
        winddirection: '西南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '60-72',
        meteorological: '晴',
        winddirection: '东北东',
        windpower: '4-5',
        waveheight: null,
        visibility: '&amp;lt;1',
      },
    ],
  },
  {
    seaarea: '山东半岛南部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '36',
    centerlongititude: '121.22',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '西南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '&amp;lt;1',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '36-48',
        meteorological: '阴',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '&amp;lt;1',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '60-72',
        meteorological: '小雨',
        winddirection: '东北东',
        windpower: '4-5',
        waveheight: null,
        visibility: '9',
      },
    ],
  },
  {
    seaarea: '汕头沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '23.26',
    centerlongititude: '117.3',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '阵雨',
        winddirection: '南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '36-48',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '汕尾沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '22.573',
    centerlongititude: '115.64',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '14',
      },
      {
        forecastaging: '12-24',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '大雨',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '17',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '上海沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '31.41',
    centerlongititude: '122.51',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阵雨',
        winddirection: '南南西',
        windpower: '5-6',
        waveheight: null,
        visibility: '1',
      },
      {
        forecastaging: '12-24',
        meteorological: '阵雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '4',
      },
      {
        forecastaging: '24-36',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '36-48',
        meteorological: '阵雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '48-60',
        meteorological: '阵雨',
        winddirection: '东风',
        windpower: '6-7',
        waveheight: null,
        visibility: '2',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '西风',
        windpower: '6-7',
        waveheight: null,
        visibility: '2',
      },
    ],
  },
  {
    seaarea: '唐山沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '39.3',
    centerlongititude: '119.32',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '晴',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '12-24',
        meteorological: '多云',
        winddirection: '南南西',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东南风',
        windpower: '3-4',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '48-60',
        meteorological: '晴',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '60-72',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '12',
      },
    ],
  },
  {
    seaarea: '盐城沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '33.64',
    centerlongititude: '121.57',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '多云',
        winddirection: '东北风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '12-24',
        meteorological: '小雨',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '24-36',
        meteorological: '多云',
        winddirection: '东风',
        windpower: '5-6',
        waveheight: null,
        visibility: '11',
      },
      {
        forecastaging: '36-48',
        meteorological: '阵雨',
        winddirection: '东风',
        windpower: '6-7',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '48-60',
        meteorological: '大雨',
        winddirection: '东风',
        windpower: '7-8',
        waveheight: null,
        visibility: '7',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '东北东',
        windpower: '7-8',
        waveheight: null,
        visibility: '9',
      },
    ],
  },
  {
    seaarea: '湛江沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '20.98',
    centerlongititude: '111.05',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '6-7',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '12-24',
        meteorological: '大雨',
        winddirection: '南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '10',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '南南东',
        windpower: '5-6',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '36-48',
        meteorological: '大雨',
        winddirection: '南南东',
        windpower: '5-6',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '48-60',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '18',
      },
      {
        forecastaging: '60-72',
        meteorological: '中雨',
        winddirection: '东南风',
        windpower: '4-5',
        waveheight: null,
        visibility: '10',
      },
    ],
  },
  {
    seaarea: '浙江北部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '30.2',
    centerlongititude: '122.62',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '阵雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '7',
      },
      {
        forecastaging: '12-24',
        meteorological: '大雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '2',
      },
      {
        forecastaging: '24-36',
        meteorological: '大雨',
        winddirection: '东南东',
        windpower: '5-6',
        waveheight: null,
        visibility: '5',
      },
      {
        forecastaging: '36-48',
        meteorological: '阵雨',
        winddirection: '东南东',
        windpower: '5-6',
        waveheight: null,
        visibility: '3',
      },
      {
        forecastaging: '48-60',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '7',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '5',
      },
    ],
  },
  {
    seaarea: '浙江南部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '27.63',
    centerlongititude: '121.98',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '雷阵雨',
        winddirection: '西南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '6',
      },
      {
        forecastaging: '12-24',
        meteorological: '阵雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '2',
      },
      {
        forecastaging: '24-36',
        meteorological: '雷阵雨',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '6',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '西南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '4',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '南南西',
        windpower: '5-6',
        waveheight: null,
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '西南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '6',
      },
    ],
  },
  {
    seaarea: '浙江中部沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '28.61',
    centerlongititude: '122.45',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '雷阵雨',
        winddirection: '西南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '6',
      },
      {
        forecastaging: '12-24',
        meteorological: '阵雨',
        winddirection: '东北风',
        windpower: '5-6',
        waveheight: null,
        visibility: '2',
      },
      {
        forecastaging: '24-36',
        meteorological: '雷阵雨',
        winddirection: '东北风',
        windpower: '5-6',
        waveheight: null,
        visibility: '6',
      },
      {
        forecastaging: '36-48',
        meteorological: '多云',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '4',
      },
      {
        forecastaging: '48-60',
        meteorological: '阴',
        winddirection: '南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '8',
      },
      {
        forecastaging: '60-72',
        meteorological: '阴',
        winddirection: '南南西',
        windpower: '6-7',
        waveheight: null,
        visibility: '6',
      },
    ],
  },
  {
    seaarea: '珠江口外沿岸',
    publishtime: '2024年06月24日08时',
    centerlatitude: '22.05',
    centerlongititude: '114',
    weatherdetail: [
      {
        forecastaging: '00-12',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '6-7',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '12-24',
        meteorological: '大雨',
        winddirection: '南南东',
        windpower: '6-7',
        waveheight: null,
        visibility: '9',
      },
      {
        forecastaging: '24-36',
        meteorological: '中雨',
        winddirection: '南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '15',
      },
      {
        forecastaging: '36-48',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '5-6',
        waveheight: null,
        visibility: '12',
      },
      {
        forecastaging: '48-60',
        meteorological: '阵雨',
        winddirection: '南南东',
        windpower: '3-4',
        waveheight: null,
        visibility: '17',
      },
      {
        forecastaging: '60-72',
        meteorological: '阵雨',
        winddirection: '东南风',
        windpower: '≤3',
        waveheight: null,
        visibility: '13',
      },
    ],
  },
]

export const portList = [
  {
    id: '04d75334-d8f6-11e9-a25f-005056c00008',
    nameCN: '茂名港',
    nameEN: '',
    lat: 21.466861,
    lng: 111.06675,
  },
  {
    id: '11ae68c8-d8f6-11e9-9687-005056c00008',
    nameCN: '南通港',
    nameEN: '',
    lat: 32.000194,
    lng: 120.80025,
  },
  {
    id: '139ebde4-d854-11e9-9816-005056c00008',
    nameCN: '广州港',
    nameEN: '',
    lat: 23.083556,
    lng: 113.433333,
  },
  {
    id: '15895c46-d8f2-11e9-96ec-005056c00008',
    nameCN: '八所港',
    nameEN: '',
    lat: 19.1,
    lng: 108.6,
  },
  {
    id: '1cbd6d3e-d8f6-11e9-b3d4-005056c00008',
    nameCN: '宁波舟山港',
    nameEN: '',
    lat: 29.966667,
    lng: 121.783333,
  },
  {
    id: '2274e0f4-d855-11e9-9a86-005056c00008',
    nameCN: '维多利亚港',
    nameEN: '',
    lat: 22.283417,
    lng: 114.15,
  },
  {
    id: '265ae7dc-d8f6-11e9-948c-005056c00008',
    nameCN: '莆田港',
    nameEN: '',
    lat: 25.200028,
    lng: 118.983333,
  },
  {
    id: '2c89ac08-d8f6-11e9-9bf5-005056c00008',
    nameCN: '秦皇岛港',
    nameEN: '',
    lat: 39.900167,
    lng: 119.600194,
  },
  {
    id: '2e20ce36-d854-11e9-9c17-005056c00008',
    nameCN: '黄骅港',
    nameEN: '',
    lat: 38.316806,
    lng: 117.866806,
  },
  {
    id: '2edc068c-d855-11e9-8961-005056c00008',
    nameCN: '温州港',
    nameEN: '',
    lat: 28.016833,
    lng: 120.650083,
  },
  {
    id: '319895a8-d8f2-11e9-9893-005056c00008',
    nameCN: '丹东港',
    nameEN: '',
    lat: 39.816722,
    lng: 124.15,
  },
  {
    id: '339b3674-d8f6-11e9-b9ef-005056c00008',
    nameCN: '青岛港',
    nameEN: '',
    lat: 36.083333,
    lng: 120.316667,
  },
  {
    id: '34549b9c-d854-11e9-8810-005056c00008',
    nameCN: '惠州港',
    nameEN: '',
    lat: 22.683528,
    lng: 114.550194,
  },
  {
    id: '39995fa2-d8f6-11e9-9cfb-005056c00008',
    nameCN: '清澜港',
    nameEN: '',
    lat: 19.550222,
    lng: 110.81675,
  },
  {
    id: '3d9587cc-d854-11e9-8dca-005056c00008',
    nameCN: '基隆港',
    nameEN: '',
    lat: 25.150167,
    lng: 121.750111,
  },
  {
    id: '3fc79b10-d8f6-11e9-9531-005056c00008',
    nameCN: '泉州港',
    nameEN: '',
    lat: 24.883556,
    lng: 118.66675,
  },
  {
    id: '43b9f77a-d855-11e9-995f-005056c00008',
    nameCN: '烟台港',
    nameEN: '',
    lat: 37.533583,
    lng: 121.383556,
  },
  {
    id: '4625738c-d8f6-11e9-b21f-005056c00008',
    nameCN: '日照港',
    nameEN: '',
    lat: 35.383333,
    lng: 119.55,
  },
  {
    id: '47719414-d854-11e9-bcec-005056c00008',
    nameCN: '江阴港',
    nameEN: '',
    lat: 31.916667,
    lng: 120.233333,
  },
  {
    id: '4bf41338-d8f6-11e9-a831-005056c00008',
    nameCN: '三亚港',
    nameEN: '',
    lat: 18.233389,
    lng: 109.483333,
  },
  {
    id: '4d79f346-d8f2-11e9-9e3a-005056c00008',
    nameCN: '福州港',
    nameEN: '',
    lat: 25.983333,
    lng: 119.45,
  },
  {
    id: '4f7d4a28-d855-11e9-bc48-005056c00008',
    nameCN: '扬州港',
    nameEN: '',
    lat: 32.266806,
    lng: 119.433333,
  },
  {
    id: '671045ac-d8f6-11e9-8910-005056c00008',
    nameCN: '上海港',
    nameEN: '',
    lat: 31.383472,
    lng: 121.500083,
  },
  {
    id: '6bdb49ca-d854-11e9-bbac-005056c00008',
    nameCN: '南京港',
    nameEN: '',
    lat: 32.083528,
    lng: 118.716667,
  },
  {
    id: '761d5338-d855-11e9-ad02-005056c00008',
    nameCN: '镇江港',
    nameEN: '',
    lat: 32.216667,
    lng: 119.433472,
  },
  {
    id: '8319fad4-d854-11e9-a9fd-005056c00008',
    nameCN: '盘锦港',
    nameEN: '',
    lat: 40.700167,
    lng: 121.950167,
  },
  {
    id: '84050486-d8f6-11e9-a942-005056c00008',
    nameCN: '台中港',
    nameEN: '',
    lat: 24.283361,
    lng: 120.5,
  },
  {
    id: '8ac70cca-d8f6-11e9-b3af-005056c00008',
    nameCN: '台州港',
    nameEN: '',
    lat: 28.683333,
    lng: 121.45,
  },
  {
    id: '91333d9c-d8f6-11e9-843b-005056c00008',
    nameCN: '唐山港',
    nameEN: '',
    lat: 39.200222,
    lng: 119.000222,
  },
  {
    id: '98e63d68-d8f6-11e9-b9b1-005056c00008',
    nameCN: '天津港',
    nameEN: '',
    lat: 38.983361,
    lng: 117.7,
  },
  {
    id: 'a12c6dc6-d8f6-11e9-a82e-005056c00008',
    nameCN: '威海港',
    nameEN: '',
    lat: 37.500167,
    lng: 122.116806,
  },
  {
    id: 'aad2b634-d8f5-11e9-ab02-005056c00008',
    nameCN: '高雄港',
    nameEN: '',
    lat: 22.616667,
    lng: 120.250111,
  },
  {
    id: 'adbe272e-d8f6-11e9-a0ff-005056c00008',
    nameCN: '潍坊港',
    nameEN: '',
    lat: 37.233333,
    lng: 119.183472,
  },
  {
    id: 'b09d0ffa-d8f5-11e9-96c6-005056c00008',
    nameCN: '广西北部湾港北海港域',
    nameEN: '',
    lat: 21.466889,
    lng: 109.083333,
  },
  {
    id: 'b6f04778-d853-11e9-962a-005056c00008',
    nameCN: '澳门港',
    nameEN: '',
    lat: 22.183556,
    lng: 113.55,
  },
  {
    id: 'b76a2eee-d854-11e9-a8c0-005056c00008',
    nameCN: '汕头港',
    nameEN: '',
    lat: 23.35,
    lng: 116.66675,
  },
  {
    id: 'b7f6a23a-d8f5-11e9-8cb9-005056c00008',
    nameCN: '广西北部湾港防城港域',
    nameEN: '',
    lat: 21.616667,
    lng: 108.333333,
  },
  {
    id: 'bcd20c78-d8f6-11e9-99d8-005056c00008',
    nameCN: '厦门港',
    nameEN: '',
    lat: 24.45,
    lng: 118.066667,
  },
  {
    id: 'bd59770a-d854-11e9-98bf-005056c00008',
    nameCN: '汕尾港',
    nameEN: '',
    lat: 22.766667,
    lng: 115.350111,
  },
  {
    id: 'bd704154-d8f5-11e9-95b9-005056c00008',
    nameCN: '广西北部湾港钦州港域',
    nameEN: '',
    lat: 21.716667,
    lng: 108.583472,
  },
  {
    id: 'bf00faae-d853-11e9-972e-005056c00008',
    nameCN: '滨州港',
    nameEN: '',
    lat: 38.3,
    lng: 118.133333,
  },
  {
    id: 'c4bef800-d853-11e9-bbaf-005056c00008',
    nameCN: '潮州港',
    nameEN: '',
    lat: 23.6,
    lng: 116.966667,
  },
  {
    id: 'cc8dd19c-d853-11e9-8693-005056c00008',
    nameCN: '大连港',
    nameEN: '',
    lat: 38.933361,
    lng: 121.650167,
  },
  {
    id: 'ccc387b6-d8f6-11e9-9539-005056c00008',
    nameCN: '盐城港',
    nameEN: '',
    lat: 33.266667,
    lng: 120.766667,
  },
  {
    id: 'd46786cc-d8f5-11e9-acba-005056c00008',
    nameCN: '海口港',
    nameEN: '',
    lat: 20.016778,
    lng: 110.266806,
  },
  {
    id: 'd5d3b1da-d8f6-11e9-9664-005056c00008',
    nameCN: '阳江港',
    nameEN: '',
    lat: 21.700139,
    lng: 111.800194,
  },
  {
    id: 'd8df8c06-d8f5-11e9-afbd-005056c00008',
    nameCN: '葫芦岛港',
    nameEN: '',
    lat: 40.700139,
    lng: 120.9835,
  },
  {
    id: 'd99bf718-d854-11e9-ac8a-005056c00008',
    nameCN: '深圳港东部港区',
    nameEN: '',
    lat: 22.566806,
    lng: 114.25025,
  },
  {
    id: 'dbcfcb9e-d8f6-11e9-b983-005056c00008',
    nameCN: '洋浦港',
    nameEN: '',
    lat: 19.716889,
    lng: 109.2,
  },
  {
    id: 'dc6af324-d8f5-11e9-84bf-005056c00008',
    nameCN: '花莲港',
    nameEN: '',
    lat: 23.9835,
    lng: 121.616833,
  },
  {
    id: 'dd07597e-d853-11e9-ad24-005056c00008',
    nameCN: '东莞港',
    nameEN: '',
    lat: 22.800194,
    lng: 113.600222,
  },
  {
    id: 'e14e5a9e-d854-11e9-a3fa-005056c00008',
    nameCN: '深圳港西部港区',
    nameEN: '',
    lat: 22.466889,
    lng: 113.900111,
  },
  {
    id: 'e3ad4bb6-d8f6-11e9-8d76-005056c00008',
    nameCN: '营口港',
    nameEN: '',
    lat: 40.283528,
    lng: 122.1,
  },
  {
    id: 'e69aba36-d854-11e9-8a40-005056c00008',
    nameCN: '苏澳港',
    nameEN: '',
    lat: 24.600028,
    lng: 121.866806,
  },
  {
    id: 'e6d66d08-d853-11e9-a3b5-005056c00008',
    nameCN: '东营港',
    nameEN: '',
    lat: 38.1,
    lng: 118.983333,
  },
  {
    id: 'ebd838b8-d854-11e9-a753-005056c00008',
    nameCN: '苏州港',
    nameEN: '',
    lat: 31.966667,
    lng: 120.400083,
  },
  {
    id: 'ece0e4f0-d8f5-11e9-86a4-005056c00008',
    nameCN: '嘉兴港',
    nameEN: '',
    lat: 30.6,
    lng: 121.083333,
  },
  {
    id: 'eeb7a89e-d8f6-11e9-8873-005056c00008',
    nameCN: '湛江港',
    nameEN: '',
    lat: 21.216861,
    lng: 110.416722,
  },
  {
    id: 'f7fa7110-d8f5-11e9-b3f9-005056c00008',
    nameCN: '锦州港',
    nameEN: '',
    lat: 40.800028,
    lng: 121.066778,
  },
  {
    id: 'fc9afab4-d8f5-11e9-bf40-005056c00008',
    nameCN: '连云港港',
    nameEN: '',
    lat: 34.733333,
    lng: 119.45,
  },
  {
    id: 'fef759ee-d8f6-11e9-8e71-005056c00008',
    nameCN: '珠海港',
    nameEN: '',
    lat: 21.9335,
    lng: 113.216889,
  },
]

export const UserAreas = [
  {
    AreaID: '4AAA5919-DD25-414F-A9A5-23710542420A',
    UserName: 'yhtest',
    AreaName: '圆形数据',
    AreaType: 0,
    AreaShape: 2,
    Points: '12.000000,12.000000',
    Radius: 12,
    Remark: '',
    IsShow: 1,
    GroupID: null,
    ZoomLevel: '[1,18]',
    AreaStyle:
      '{"color":"rgb(164, 59, 59,1)","fillColor":"rgb(164, 59, 59,1)","fillOpacity":0.2,"dashArray":[5,5],"weight":1}',
  },
  {
    AreaID: '8D0224A3-C821-4EDC-B2D1-6FAD48580C88',
    UserName: 'yhtest',
    AreaName: '多边形数据',
    AreaType: 0,
    AreaShape: 1,
    Points:
      '7.778320,14.360191,6.152344,13.656663,7.250977,12.479487,7.229004,13.197165,7.152100,13.517838,8.811035,13.806075,9.063721,13.229251,10.371094,14.083301,9.448242,14.445319,8.789063,14.796128,7.800293,15.135764,7.976074,14.785505',
    Radius: 0,
    Remark: '',
    IsShow: 1,
    GroupID: null,
    ZoomLevel: '[1,18]',
    AreaStyle:
      '{"color":"rgba(255,0,0)","fillColor":"rgba(255,0,0)","fillOpacity":0.2,"dashArray":[5,5],"weight":1}',
  },
  {
    AreaID: 'C8EA55EA-EDA9-429B-95F9-F9CC8D91FE1A',
    UserName: 'yhtest',
    AreaName: '长方形或正方形',
    AreaType: 0,
    AreaShape: 0,
    Points:
      '8.344116,11.820604,8.344116,12.679614,11.200562,12.679614,11.200562,11.820604',
    Radius: 0,
    Remark: '',
    IsShow: 1,
    GroupID: null,
    ZoomLevel: '[1,18]',
    AreaStyle:
      '{"color":"rgba(255,0,0)","fillColor":"rgba(255,0,0)","fillOpacity":0.2,"dashArray":[5,5],"weight":1}',
  },
]
export const UserMarkers = [
  {
    MarkerID: '1CEA8E33-CC55-4B79-A086-81027B756763',
    MarkerName: '12',
    MarkerType: 20,
    Lat: 12.033333,
    Lon: 12.033333,
    IsShow: 1,
  },
]
export const UserLines = [
  {
    LineID: '193AAB0D-C3B4-4622-9662-A0523B853A3D',
    LineName: 'hhh',
    Points:
      '11.9696044921875,12.077595751733533,11.827468872070312,11.982569230068208,11.742668151855469,11.998017521153082,11.682586669921875,11.983240913289094,11.620101928710938,11.976859855224403,11.658554077148438,11.878774151411488,11.77734375,11.854583194565883,11.825065612792969,11.927821437111179',
    IsShow: 1,
    Distance: 41.2,
    Style: '{"color":"","dashArray":[5,5],"weight":1,"lineTextColor":""}',
  },
]
